<template>
  <div
    class="logo"
    v-html="logo"
  />
</template>

<script>
import * as Logos from '@running_app_src/components/svg/logos'

export default {
  name: 'logo',

  props: {
    type: String,
  },

  data() {
    return {
      main_logo: this.get_config('guiSettings.customizations.mainLogo', false)
    }
  },

  computed: {

    logo() {
      if(this.type === 'logo_headline_custom') return `<img alt='logo' src='${this.main_logo}' />`
      return Logos[this.type.replace('-','_')] || ''
    },

  },

  created() {
  },

  mounted() {
  },
}
</script>

<style lang="scss" scoped>

  .logo {
    width: min(180px, 32vw);
    max-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep * {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

</style>